import ProviderSlide from "../../components/providers-slide";
import PopularGames from "../../components/popular-games";
import MobileFilter from "../../components/mobile-filter";
import React, {useEffect} from "react";
import TopGames from "../../components/top-games";
import NewGames from "../../components/new-games";
import FreeSpinGames from "../../components/freespin-games";
import HighRtpGames from "../../components/high-rtp-games";
import JackpotGames from "../../components/jackpot-games";
import BuyBonusGames from "../../components/buy-bonus-games";
import GeneralStats from "../../components/debit-table/casino-debit-stats";
import SearchResults from "../casino-group/search-results";
import {useSelector} from "react-redux";
import MiniSlider from "../homepage/mini-slider";
import associateServices from "../../services";
import SlotLobbyGroups from "./group";

const Casino = () => {
    const {agent} = useSelector(state => state.globalReducer)


    return (
        <div className="container">
            <MiniSlider rowItem={3} page={'slots'}/>

            <div className="container section">
                {
                    agent?.isMobile ? <MobileFilter/> :
                        <SearchResults type={'slots'}/>
                }
            </div>


            <SlotLobbyGroups/>

            {/*<TopGames/>*/}

            {/*<PopularGames/>*/}

            {/*<NewGames/>*/}

            {/*<FreeSpinGames/>*/}


            {/*<HighRtpGames/>*/}


            {/*<JackpotGames/>*/}

            {/*<BuyBonusGames/>*/}


            <GeneralStats/>
            <ProviderSlide type={'slots'}/>

        </div>


    )

}

export default Casino
